import { render, staticRenderFns } from "./FeeServiceCategory.vue?vue&type=template&id=1cfd656a&scoped=true&"
import script from "./FeeServiceCategory.vue?vue&type=script&lang=js&"
export * from "./FeeServiceCategory.vue?vue&type=script&lang=js&"
import style0 from "./FeeServiceCategory.vue?vue&type=style&index=0&id=1cfd656a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cfd656a",
  null
  
)

export default component.exports